import React, { useEffect } from 'react'
import { ConfigProvider } from 'antd'
import type { ThemeConfig } from 'antd/es/config-provider'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

const setFavicon = (url: string) => {
  let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null

  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }

  link.href = url
}

const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { IS_HOSPITAL } = useFeatureFlags()

  // Dynamically set favicon
  useEffect(() => {
    const faviconPath = IS_HOSPITAL ? '/k-favicon.ico' : '/cg-favicon.ico'
    setFavicon(faviconPath)
  }, [IS_HOSPITAL])

  const commonTokens = {
    fontFamily: '"Open Sans", Arial, sans-serif',
  }

  // Define the colors as variables
  const hospitalPrimary = '#005883'
  const hospitalSecondary = '#00A3E0'
  const cgPrimary = '#045c64' // Silelifelab Teal color
  const cgSecondary = '#4c979f' // Silelifelab Aqua color
  const darkItemColor = '#ffffff'

  const themeConfig: ThemeConfig = IS_HOSPITAL
    ? {
        cssVar: true,
        token: {
          colorPrimary: hospitalPrimary,
          colorTextSecondary: hospitalSecondary,
          ...commonTokens,
        },
        components: {
          Layout: {
            headerBg: hospitalPrimary,
            footerBg: hospitalPrimary,
          },
          Menu: {
            darkItemBg: hospitalPrimary,
            darkItemColor: darkItemColor,
            darkItemHoverColor: hospitalSecondary,
            darkItemSelectedColor: hospitalSecondary,
          },
        },
      }
    : {
        cssVar: true,
        token: {
          colorPrimary: cgPrimary,
          colorLink: cgSecondary,
          colorTextSecondary: cgSecondary,
          ...commonTokens,
        },
        components: {
          Layout: {
            headerBg: cgPrimary,
            footerBg: cgPrimary,
          },
          Menu: {
            darkItemBg: cgPrimary,
            darkItemColor: darkItemColor,
            darkItemHoverColor: cgSecondary,
            darkItemSelectedColor: cgSecondary,
          },
        },
      }

  return <ConfigProvider theme={themeConfig}>{children}</ConfigProvider>
}

export default ThemeProviderWrapper
